// Tied to backend, do not rename values
export enum CsvInteractionExportType {
    DISTRIBUTION = 'DISTRIBUTION',
    PHONE = 'ADHOC_PHONE',
    EMAIL = 'ADHOC_EMAIL',
    DIRECT_MESSAGE = 'ADHOC_MESSAGE',
    INBOUND_INQUIRY = 'ADHOC_INBOUND_INQUIRY',
    OTHER = 'ADHOC_OTHER',
}
